import { render, staticRenderFns } from "./TipoDeMovimentacao.vue?vue&type=template&id=6e10f7bf&"
import script from "./TipoDeMovimentacao.vue?vue&type=script&lang=js&"
export * from "./TipoDeMovimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports